import PropTypes from 'prop-types';
import { redirectToPath } from '../../utils/redirectToPath';

const RedirectTo = ({ location: { search } }) => {
  const params = new URLSearchParams(search);
  const decodedString = decodeURIComponent(params.get('to'));

  return redirectToPath(decodedString);
};

RedirectTo.propTypes = {
  location: PropTypes.shape(),
};

export default RedirectTo;
